import { Dialog, DialogContent } from "@theprelude/ds";
import { Suspense } from "react";

import { ErrorBoundary } from "react-error-boundary";
import { AppErrorPage } from "./app-shell/app-shell";

export function DialogErrorFallback({ error }: { error: unknown }) {
  return <AppErrorPage error={error} />;
}

function DialogLoading() {
  return (
    <div className="flex flex-col gap-4 px-4">
      <div className="h-[32px] w-full animate-pulse rounded-md bg-secondary-foreground" />
      <div className="h-[96px] w-full animate-pulse rounded-md bg-secondary-foreground" />
    </div>
  );
}

export function DefaultDialog({
  children,
  open,
  onOpenChange,
}: {
  children: React.ReactNode;
  open: boolean;
  onOpenChange: (value: boolean) => any;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <ErrorBoundary FallbackComponent={DialogErrorFallback}>
          <Suspense fallback={<DialogLoading />}>{children}</Suspense>
        </ErrorBoundary>
      </DialogContent>
    </Dialog>
  );
}
